import { Layout, Avatar, Dropdown, Space, Typography, Divider, Button } from 'antd';
import { DownOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';
import LanguageSwitcher from '../common/languageSwitcher';
import CountrySwitcher from '../common/countrySwitcher';
import { useMsal } from '@azure/msal-react';
import { useUserAuth } from '../../context/UserContext';
import { usePageTitle } from '../../context/pageTitleContext';
import NotificationBadge from '../common/notificationBadge';
import { useTranslation } from 'react-i18next';
const { Header } = Layout;
const { Text, Title } = Typography;

const AppHeader = () => {
    const { instance } = useMsal();
    const { user } = useUserAuth();
    const { pagetitle } = usePageTitle();
    const { t } = useTranslation();

    const handleLogout = () => {
        instance.logoutRedirect();
    };

    const items = [
        {
            label: (<Text onClick={handleLogout}><LogoutOutlined /> {t('general.singOut')}</Text>),
            key: '1',
        }
    ];

    return (
        <Header className='appheader'>
            <Space className='pagetitle'>
                <Title level={5} style={{ color: "#ffffff" }}>{pagetitle}</Title>
            </Space>

            <Space direction='horizontal' className='menuDivider'>
                {user && (<>
                    <CountrySwitcher />
                    <Divider type="vertical" />
                </>
                )}

                {user && (
                    <Space direction='horizontal'>
                        <Dropdown menu={{ items }}>
                            <Button type='text'>
                                <Space>
                                    <Avatar icon={<UserOutlined />} />
                                    <Text style={{ color: "#ffffff" }}>{user.name + " " + user.surname} - {user.roleName}</Text> <DownOutlined style={{ color: "#ffffff" }} />
                                </Space>
                            </Button>
                        </Dropdown>
                    </Space>
                )}

                {/* <Divider type="vertical" />
                <LanguageSwitcher /> */}

                {/* <Divider type="vertical" /> */}
                {/* <NotificationBadge /> */}
            </Space>

        </Header>
    );
}


export default AppHeader;